import React from "react";
import Navbar from "../component/Navbar";
import Footer from "../component/Footer";

import beachVideo from "../images/beach.mp4";

function Home() {
	return (
		<div>
			<Navbar />
			<video
				loop
				autoPlay
				muted
				className="bg-vid"
			>
				<source
					src={beachVideo}
					type="video/mp4"
				/>
			</video>
			<h1>Travel to Santorini</h1>
			<h4 className="text-center">
				Discover the beauty of this island set against the sparkling Aegean,
				with volcanic sand beaches and topped by whitewashed buildings.
			</h4>
			<Footer />
		</div>
	);
}

export default Home;
